import React from 'react';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../../i18n';
import { Button } from '../ui/button';
import { Globe, Check } from 'lucide-react';

const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'tr', name: 'Türkçe', flag: '🇹🇷' }
];

const LanguageTab = () => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
  };

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-3 mb-6">
        <Globe className="w-6 h-6 text-emerald-400" />
        <h2 className="text-xl font-bold text-white">{t('language.language')}</h2>
      </div>

      <div className="bg-zinc-800/50 rounded-lg p-4">
        <p className="text-zinc-400 text-sm mb-4">
          {t('language.selectLanguage')}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageChange(lang.code)}
              className={`flex items-center gap-3 p-4 rounded-lg border-2 transition-all ${
                currentLanguage === lang.code
                  ? 'border-emerald-500 bg-emerald-500/10'
                  : 'border-zinc-700 bg-zinc-800/50 hover:border-zinc-600'
              }`}
            >
              <span className="text-2xl">{lang.flag}</span>
              <div className="flex-1 text-left">
                <p className="text-white font-medium">{lang.name}</p>
                <p className="text-zinc-500 text-xs">
                  {lang.code === 'en' ? 'English' : 'Turkish'}
                </p>
              </div>
              {currentLanguage === lang.code && (
                <Check className="w-5 h-5 text-emerald-400" />
              )}
            </button>
          ))}
        </div>
      </div>

      <div className="bg-zinc-800/30 rounded-lg p-4 border border-zinc-700">
        <h3 className="text-white font-medium mb-2">{t('language.currentLanguage')}</h3>
        <div className="flex items-center gap-2">
          <span className="text-xl">
            {languages.find(l => l.code === currentLanguage)?.flag}
          </span>
          <span className="text-zinc-300">
            {languages.find(l => l.code === currentLanguage)?.name}
          </span>
        </div>
      </div>

      <div className="text-zinc-500 text-sm">
        <p>• {currentLanguage === 'tr' ? 'Dil değişikliği anında uygulanır' : 'Language change is applied instantly'}</p>
        <p>• {currentLanguage === 'tr' ? 'Tercih tarayıcınızda kaydedilir' : 'Preference is saved in your browser'}</p>
      </div>
    </div>
  );
};

export default LanguageTab;
